
export const ROUTES = {
  ROOT: '/',
  SIGN_IN: '/signin',
  SCREENS: '/screens',
  LOCATIONS: '/locations',
}